var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"promise-file-wrapper"},[_c('img',{attrs:{"src":"https://files.jinr.com/jinr-index/img/promise-file-01.png","alt":"","srcset":""}}),_c('img',{attrs:{"src":"https://files.jinr.com/jinr-index/img/promise-file-02.png","alt":"","srcset":""}})])
}]

export { render, staticRenderFns }